<template>
  <ion-app>
    <ion-content>
      <v-container fluid id="classifyList">
        <div class="van-hairline--bottom van-nav-bar" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
          <div class="van-ellipsis van-nav-bar__title">
            {{ $t("category.title") }}
          </div>
        </div>

        <div class="classify_container">
          <!-- <v-tabs fixed-tabs>
            <v-tab v-for="(item, id) in topClassify" :key="id" >{{ item.Title }}</v-tab>
          </v-tabs> -->
          <div v-show="$vuetify.breakpoint.smAndDown">
            <van-sidebar v-model="curSideBarIndex" class="classify_sidebar">
              <van-sidebar-item v-for="(item, id) in topClassify" :key="id" :title="item.Title" @click="onClickTopClassify(item)" />
            </van-sidebar>
          </div>

          <div class="classify_box">
            <div class="classify_title" v-show="$vuetify.breakpoint.smAndDown">
              <h3>{{ curClassifyTitle }}</h3>
            </div>

            <v-data-iterator :items="secondClassifyList" hide-default-footer :items-per-page="50" class="d-flex flex-column overflow-hidden">
              <template v-slot:no-data>
                <v-progress-linear style="width: 90vw !important;" indeterminate color="cyan"></v-progress-linear>
              </template>

              <template v-slot:default="props">
                <v-row dense align="center" align-content="center">
                  <v-col v-for="item in props.items" :key="item.name" cols="4" sm="3" @click="onClickSecondClassify(item)">
                    <v-card flat class="card fill-height classify-item">
                      <img v-lazy="item.ImagePath" />
                      <div class="sub_classify_title">
                        {{ item.Title }}
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </div>
        </div>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      curSideBarIndex: 0,
      secondClassifyList: [],
      curClassify: null,
      curClassifyTitle: "",
      prevClassify: null,
      prevClassifyTitle: "",
    };
  },
  computed: {
    topClassify() {
      return this.$store.state.topClassify;
    },
  },
  activated() {
    this.$parent.curTab = 2;
    this.$parent.handleScroll(null);
  },
  mounted() {
    if (!this.$enableCategories) this.$router.replace({ name: "home" });
    this.$parent.curTab = 2;
    this.loadStates();
    this.getTopClassify();
  },
  methods: {
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      if (this.$route.params.code) {
        this.getCategory(this.$route.params.code);
      } else if (this.$store.state.classifyList) {
        if ("classify" in this.$store.state.classifyList) {
          this.curClassify = this.$store.state.classifyList.classify;
          if (this.curClassify != null && "index" in this.curClassify) {
            this.curSideBarIndex = this.curClassify;
          }
          this.getSecondClassifyList(this.curClassify);
        }
      }
    },
    // ------------------------------------------------------------------------ saveStates
    saveStates() {
      this.$store.commit("classifyList", {
        classify: this.curClassify,
      });
    },
    // ------------------------------------------------------------------------ getCategory
    getCategory(categoryId) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        categoryId: categoryId,
      };
      $this.$ajax2
        .post("GetCategory", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.curClassify = rpdata.data.data;
            $this.getSecondClassifyList($this.curClassify);
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getTopClassify
    getTopClassify() {
      let $this = this;
      if (this.topClassify.length == 0) {
        let obj = {
          AppVersion: this.$version,
          language: localStorage.getItem("lang"),
        };
        $this.$ajax2
          .post("GetCategories", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              for (let i = 0; i < rpdata.data.data.length; i++) {
                rpdata.data.data[i].index = i;
              }
              $this.$store.commit("topClassify", rpdata.data.data);
              // additional job
              if ($this.curClassify) {
                $this.onClickTopClassify($this.curClassify);
              } else {
                $this.onClickTopClassify($this.topClassify[0]);
              }
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      } else {
        // replace additional job
        if ($this.curClassify) {
          $this.onClickTopClassify($this.curClassify);
        } else {
          $this.onClickTopClassify($this.topClassify[0]);
        }
      }
    },
    // ------------------------------------------------------------------------ getSecondClassifyList
    getSecondClassifyList(data) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        categoryId: data.Id,
      };
      $this.secondClassifyList = [];
      $this.$ajax2
        .post("GetCategories", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            if (rpdata.data.data.length == 0) {
              $this.curClassify = $this.prevClassify;
              $this.saveStates();
              $this.onClickSecondClassify(data);
            } else {
              if ($this.topClassify.length > 0) {
                let idx = -1;
                for (let i = 0; i < $this.topClassify.length; i++) {
                  if ($this.topClassify[i].Id == data.Id) {
                    idx = i;
                    break;
                  }
                }
                //if (idx >= 0 && idx != $this.$store.state.curTopTab) {
                //$this.$store.commit("curTopTab", idx);
                if (idx >= 0 && idx != $this.$parent.topTab) {
                  $this.$parent.topTab = idx + ($this.$enableBrands ? 1 : 0); // first one is brand;
                }
              }
              $this.curClassifyTitle = data.Title;
              $this.secondClassifyList = rpdata.data.data;
            }
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickTopClassify
    onClickTopClassify(data) {
      let $this = this;
      if ($this.curClassify != data) {
        $this.prevClassify = $this.curClassify;
        $this.curClassify = data;
        $this.saveStates();
      }
      $this.curSideBarIndex = data.index;
      $this.getSecondClassifyList(data);
    },
    // ------------------------------------------------------------------------ onClickSecondClassify
    onClickSecondClassify(data) {
      let $this = this;
      $this.$store.commit("classifyProductList", { classify: data, routeBack: true });
      // $this.$store.commit("incRouteCount");
      $this.$router.push({ name: "classifyProductList", params: { code: data.Id, test1: true } });
    },
  },
};
</script>

<style>
#classifyList {
  width: 100%;
  /* background-color: #f8f8f8; */
  /* height: -webkit-fill-available; */
}

#classifyList .classify_container {
  display: flex;
}
#classifyList .classify_sidebar {
  /* width: var(--side-menu-width); */
  width: 15vh;
}

#classifyList .classify_title {
  -webkit-line-clamp: 2;
  width: 100%;
  text-align: center;
  word-break: break-word;
  overflow: hidden;
  height: 32px;
}

#classifyList .classify_box {
  flex-grow: 1;
}
#classifyList .classify_box img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
  width: 96%;
  min-height: 40%;
  min-width: 40%;
}
#classifyList .sub_classify_title {
  font-size: 11px;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* height: 3em !important; */
}

/* 
#classifyList .xvan-badge--select {
  font-weight: 500;
  border-color: #ffffff;
  color: #8cdbcc;
}
#classifyList .xvan-badge-group {
  width: 30%;
}
#classifyList .xgoodsDesc {
  position: absolute;
  bottom: 20px;
  padding: 10px 0;
  background-color: #ffffff;
  margin: 10px 0;
  opacity: 0.8;
  width: 80%;
  left: 10%;
}
#classifyList .xnewGoods {
  position: absolute;
  top: 0px;
  left: 0;
  background-color: red;
  padding: 3px 5px;
  color: #ffffff;
}
#classifyList .van-col--9 {
  width: 33%;
}
#classifyList .van-hairline--top-bottom::after {
  border-width: 0;
}
#classifyList .xindex_head {
  margin-left: 16px !important;
  margin-right: 0px !important;
  height: 44px;
}
#classifyList .xvan-search .van-cell {
  padding: 3px 0px;
  background-color: #f4f4f4;
}
#classifyList .xvan-actionsheet__cancel,
.van-actionsheet__item {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
#classifyList .xvan-actionsheet {
  max-height: 300px;
}
#classifyList .xgoods_box {
  margin-top: 10px;
  margin-bottom: 48px;
}
#classifyList .xvan-card {
  height: 80px;
}
#classifyList .xvan-card {
  padding: 20px 15px 5px 85px;
}
#classifyList .xvan-card__thumb {
  left: 0px;
  width: 90px;
  height: auto;
  position: absolute;
}
#classifyList {
  width: 100%;
  background-color: #f8f8f8;
  height: -webkit-fill-available;
}
#classifyList .header {
  height: 44px;
  line-height: 44px;
  box-shadow: 0px 2px 10px lightgrey;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: white;
}
#classifyList .header img {
  vertical-align: text-top;
}
#classifyList .search {
  border: 1px solid lightgray;
  border-radius: 30px;
  margin-top: 6px;
  background-color: #f4f4f4;
}
#classifyList .xvan-search {
  padding: 0px;
}
#classifyList .xvan-search {
  background-color: transparent !important;
}
#classifyList .classify-item img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
  width: 96%;
  min-height: 40%;
  min-width: 40%;
}
 */
</style>
